import React, { useEffect, useState } from "react";
import { routes } from "utilities/routing/generatedRoutes";

// TODO: Rewrite this with validator and section template
const ChangeSecretQuestion = () => {
  const [answerIsValid, setAnswerIsValid] = useState(true);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [selectedQuestion, setSelectedQuestion] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const secretAnswer = await window.Api.Account.GetCurrentSecretAnswer();
      const secretQuestion = await window.Api.Account.GetCurrentSecretQuestion();
      setSelectedAnswer(secretAnswer.data || "");
      setSelectedQuestion(secretQuestion.data || 0);
    }
    fetchData();
  }, []);

  const onDropdownChanged = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = parseInt(event.target.value, 10);
    setSelectedQuestion(value);
  }

  const onAnswerChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedAnswer(value);
  }

  const validateAnswerFormat = () => {
    if (selectedAnswer.trim() === "") {
      setAnswerIsValid(false);
    } else {
      setAnswerIsValid(true);
    }
  }

  const changeSecretQuestion = async () => {
    if (!answerIsValid) {
      return;
    }

    const r = await window.Api.Account.ChangeSecretQuestion({
      secretAnswer: selectedAnswer,
      secretQuestionId: selectedQuestion
    });

    if (r.data) {
      window.location.href = routes.personal_SettingMenu().absolute;
    }
  }

  return <>
    <table className="s1_table clean rowspace">
      <tbody>
        <tr>
          <td>{RESX.PersonalSettings.SecretQuestion}</td>
          <td>
            <div id="SecretQuestionHolderDiv">
              <select id="SecretQuestion" name="SecretQuestion" value={selectedQuestion} onChange={onDropdownChanged}>
                <option value="5">
                  {RESX.SecretQuestion.WhatIsTheBrandOfYourFirstCar}
                </option><option value="1">
                  {RESX.SecretQuestion.WhatIsTheNameOfYourFavoritePet}
                </option><option value="2">
                  {RESX.SecretQuestion.WhatIsTheNameOfYourHighschool}
                </option><option value="4">
                  {RESX.SecretQuestion.WhatIsYourPlaceOfBirth}
                </option><option value="3">
                  {RESX.SecretQuestion.WhatIsYourMothersMaidenName}
                </option>
              </select><br />
            </div>
          </td>
        </tr>
        <tr>
          <td>{RESX.PersonalSettings.SecretAnswer}</td>
          <td>
            <div>
              <input id="SecretAnswer" onChange={onAnswerChanged} onBlur={validateAnswerFormat} name="SecretAnswer" value={selectedAnswer || ""} type="text"
                className={!answerIsValid ? "s1_warningborder" : null} style={{ width: "100%" }} />
              <div className="grow1" style={{ color: "red" }}>
                {answerIsValid ? <div></div> : <div>{RESX.PersonalSettings.SecretAnswerCannotBeEmpty}</div>}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <div className="flex justify-end margin-top-bigger">
        <button className="button-new primary" type="button" id="btnSave" onClick={changeSecretQuestion}>{RESX.Buttons.btnSave}</button>
      </div>
    </div>
  </>
}

export default ChangeSecretQuestion;